type ContainerItemProps = {
  children: JSX.Element;
  className?: string;
};

export const ContainerItem = ({
  children,
  className = '',
}: ContainerItemProps) => {
  return (
    <div className={'flex w-full h-full p-2 ' + className}>{children}</div>
  );
};
